import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_xs4ej7t4ss: FaireBrandEntity = {
  token: "b_xs4ej7t4ss",
  type: "brand",
  name: "ALCO Jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/2b065c407beba4cdfc034c90d6fdbc951201ee4dce72491e2f209fedd23e5798.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/df45bc89c99a83a85658558dd20aa7728f1ffc842d633f35662947563a24665e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/2b065c407beba4cdfc034c90d6fdbc951201ee4dce72491e2f209fedd23e5798.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/df45bc89c99a83a85658558dd20aa7728f1ffc842d633f35662947563a24665e.png",
  location: "Destin, FL, USA",
  minimumOrderDollars: 500,
  rating: 5,
  reviewCount: 11,
  isInsider: true,
  description:
    "Welcome to the ALCO experience..\n\nA brand guided by you.\nAt ALCO, we're inspired by the power of you, and the limitless world you can create. Our water-resistant jewelry is made to be your daily reminder to live fully, reflect often, and create the life of your dreams.\n\nIncluded below are all of our current offerings in our ATS styles. ",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:52:07.322Z",
    importedBy: "entity-db-cli",
  },
};
